import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  select {
    width: 100%;
    height: 30px;
    border: none;
    outline: 0;
    font-weight: 700;
    color: #707070;
    font-size: 12px;
    padding: 8px;
  }

  &:focus-within::after {
    width: calc(100%-3.2rem);
    height: 2px;
    content: '';
    position: absolute;
    left: 1.6rem;
    right: 1.6rem;
    bottom: 0;
  }
`;

export const DropDownContainer = styled.div`
  width: 10.5em;
  margin: 0 5rem 0 0;

  @media (max-width: 600px) {
    /* width: 7.5em; */
    margin: 0 2.5rem 0 0;
  }
`;

interface DropDownPropsHeader {
  isPerfil?: boolean;
  isTimer?: boolean;
  isCredor?: boolean;
}

export const DropDownHeader = styled.div<DropDownPropsHeader>`
  width: ${(props) =>
    props.isPerfil ? '10.5em' : props.isTimer ? '9em' : '10.5em'};
  margin-top: ${(props) => (props.isPerfil ? '18px' : '0')};
  margin-bottom: 0.8em;
  padding: 0.4em 2em 0.4em 1em;
  font-weight: 400;
  font-size: 1.2rem;
  color: ${(props) => (props.isPerfil ? '#0A78CB' : '#666666')};
  background: #ffffff;
  cursor: pointer;

  border: ${(props) => (props.isTimer ? '1px solid #C4C4C4' : 'none')};
  border-radius: ${(props) => (props.isTimer ? '5px' : 'none')};

  display: flex;
  align-items: center;

  > p {
    font-size: 1.1rem;
    color: #000000;
  }

  img {
    margin-top: 1px;
    margin-left: ${(props) =>
      props.isTimer ? '36px' : props.isCredor ? '15px' : '10px'};
    width: ${(props) => (props.isTimer || props.isCredor ? '20px' : '12px')};
    height: ${(props) => (props.isTimer || props.isCredor ? '20px' : '12px')};
  }
`;

export const DropDownListContainer = styled.div<DropDownPropsHeader>`
  width: ${(props) => (!props.isCredor ? '150px' : '100px')};
  position: absolute;
  z-index: 70;
`;

export const DropDownList = styled.ul`
  margin: 0;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: var(--text-body);
  font-size: 1.1rem;
  font-weight: 400;
  text-align: center;
  &:first-child {
    padding-top: 0.8em;
  }
`;

export const ListItem = styled.li`
  list-style: none;
  margin-bottom: 0.8em;
  cursor: pointer;
`;
